import { Button, Modal, Form, Row, Col, message } from "antd";
import { PasswordInput } from "antd-password-input-strength";
import { useEffect, useState } from "react";
import zxcvbn from "zxcvbn";
import patchDataTrace from "../../../../services/patchDataTrace";

export default function UpdatePass({
  isVisible,
  selected,
  setPassModal,
  handleFetchUsers,
}: any) {
  const [isLoading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const onSubmit = async () => {
    const values = await form.getFieldsValue();
    const { password } = form.getFieldsValue();
    const score = password.length === 0 ? -1 : zxcvbn(password).score;
    if (score < 3) {
      message.error("Use stronger password");
    } else {
      const uri = `users/${selected?._id}/password/reset`;
      const response = await patchDataTrace(values, uri);
      if (response.success) {
        message.success("Updated Successfully");
        handleFetchUsers();
        form.resetFields();
        hideModal();
      } else {
        message.error(response.message);
      }
    }
  };

  const clearForm = async () => {
    form.resetFields();
  };

  const hideModal = () => {
    setPassModal(false);
  };

  useEffect(() => {
    form.resetFields();
  }, [selected]);

  return (
    <Modal
      visible={isVisible}
      title="Reset Password"
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="changePassword"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="changePassword"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
      >
        <div className="mb-4">
          <span className="mr-2">Change Password For</span>
          <span className="text-toyota">
            {selected?.firstname} {selected?.lastname}
          </span>
        </div>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: `Please enter Password`,
                },
              ]}
            >
              <PasswordInput
                inputProps={{
                  size: "middle",
                  placeholder: "Password",
                }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
